 <!--
    ************************************************************
    * PAGELOADER
    *************************************************************
    -->
    <div id="pageloader" #divPageLoad *ngIf="this.isloaded===false">
      <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
      </div>
  </div>
  <!-- ************** END : PAGELOADER **************  -->

  <!--
    ************************************************************
    * MAIN WRAPPER
    *************************************************************
    -->
    <!-- <ng-container *ngIf="this.showReport">
        <app-Report></app-Report>
    </ng-container> -->
    <ng-container  >
        <div class="mainwrapper">

            <!--
            ************************************************************
            * HEADER
            *************************************************************
            -->
            <header class="header fixed t0 l0 w100 pd-30 z9" data-ckav-sm="pd-0 block" data-scrollsticky="y">
                <div class="container-fluid z1" data-ckav-sm="w-reset w100">
                    <div class="row align-items-center typo-light" id="rowHeaderCustom">
                         <div class="col-lg-3 align-l" data-ckav-md="align-l pd-20" data-ckav-sm="align-l pd-10">
                            <a href="#index" class="inline-block mr-auto logowrp" data-ckav-md="px-w60" id="aLogoImg" data-ckav-sm="px-w40">
                              <img id="logoImg" src="./assets/images/LOGO LG VINA 2021 a.png" alt="logo">
                            </a>
      
                            <div class="menu-iconwrp" data-ckav-md="block pd-40" data-ckav-sm="block pd-10 pd-tb-tiny">
                                <div class="menu-icon" data-ckav-sm="block">
                                    <span></span>
                                </div>
                            </div>
      
                        </div>
                        <div class="col-lg-6 align-c" data-ckav-sm="align-c">

                            <ul class="list-reset nav-ul inline-block fs16 txt-white txt-upper bold-4 f-1" data-ckav-sm="block">
                                <!-- <li><a href="#home" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink active-hashlink" data-hashlink="home">Home</a></li> -->
                                <li><a href="#brand" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="brand">Thương hiệu</a></li>
                                <li><a href="#about" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="about">Khám phá</a></li>
                                <li><a href="#portfolio" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="portfolio">Điều khoản</a></li>
                                <!-- <li><a href="#contact" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="contact">Câu hỏi</a></li> -->
                                <!-- <li><a href="#social" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="social">Câu hỏi</a></li> -->
                                <li > 
                                  <!-- style="  background: linear-gradient(135deg, orange 60%, cyan);" -->
                                      <a href="#regis" class="mr-lr-30 mr-tb-10 pd-tb-10 hov-txt-default sectionlink" data-hashlink="regis">
                                          <!-- <img src="./assets/images/downArrow.png" class="animated fadeInDown infinite" alt="" style="    width: 4%;
                                          margin: auto;
                                          color: brown;"/> -->
                                          Đăng ký
                                      </a>
                                  </li>
      
                            </ul>
                        </div>
                        <ng-container *ngIf="this.showLogOut ">
                            <div class="col-lg-3 align-r" data-ckav-sm="align-c">
                                <hr class="light mr-tb-10 hidden" data-ckav-sm="block">
                                <ul class="list-reset nav-ul inline-block fs16 txt-white txt-upper bold-4 f-1" data-ckav-sm="block">
                                    <li  >
                                        <button type="button" class="btn btn-default solid fs16 f-1 txt-upper" 
                                                    (click)="logOut()"
                                                    ><i class="fa fa-envelope-o"></i> Log Out</button>
                                      <!-- <a onclick="logOut()" class="btn btn-default solid fs16 f-1 txt-upper">
                                         Log Out
                                      </a> -->
           
                                    
                                    </li>
                                </ul>
          
                               
          
                            </div>
                        </ng-container>
                    
                    </div>
                </div>
      
                <!--=================================
                = SOCIAL ICONS
                ==================================-->
                <div class="fixed b0 l0 pd-30" data-ckav-sm="pos-rel align-c">
                    <div class="inline-block">
                          <a href="https://bm.lgvina.vn/" target="_blank" style="color: #9D0010;" class="op-full sq40 fs16 mr-b-10 flex iconbox hov-txt-default txt-white" data-ckav-sm="inline-flex mr-0"><i class="fa fa-home"></i></a>
      
                        <a href="https://www.facebook.com/SOUTH.NAS.LGVINA" target="_blank" style="color: #9D0010;" class="op-full sq40 fs16 mr-b-10 flex iconbox hov-txt-default txt-white" data-ckav-sm="inline-flex mr-0"><i class="fab fa-facebook-f"></i></a>
                        <a href="#" target="_blank" style="color: #9D0010;"  class="op-full sq40 fs16 mr-b-10 flex iconbox hov-txt-default txt-white" data-ckav-sm="inline-flex mr-0"><i class="fab fa-twitter"></i></a>
                        <!-- <a href="#" target="_blank" style="color: #9D0010;"  class="op-full sq40 fs16 flex iconbox hov-txt-default txt-white" data-ckav-sm="inline-flex mr-0"><i class="fab fa-tumblr"></i></a> -->
                    </div>
                </div>
                <!-- ======= END : SOCIAL ICONS =======  -->
            </header>
            <!-- ************** END : HEADER **************  -->
      
            <!--=================================
            = BACKGROUND HOLDER
            ==================================-->
          
            <router-outlet > </router-outlet>
            <!-- ======= END : BACKGROUND HOLDER =======  -->
      
           
            <!-- ************** END : SCROLLING SECTION **************  -->
      
            <!--
            ************************************************************
            * FOOTER
            *************************************************************
            -->
            <!-- <div class="fixed b0 r0 z1 pd-40 f-1 bold-4 txt-white op-08" data-ckav-sm="pd-10 w100 align-c">
                <div class="pos-abs w100 t0 l0 h100 hidden bg-dark z-1" data-ckav-sm="block"></div>
                <a href="#" target="_blank"> - Creative One Page Template</a> © <script>document.write(new Date().getFullYear());</script> 2018	
            </div> -->
            <!-- ************** END : FOOTER **************  -->
      
            <!--
            ************************************************************
            * POPUP-SUBSCRIBE-01
            *************************************************************
            -->
            <!-- <div id="popup-content" class="white-popup-block popup-content animate fadeInDown mfp-hide">
                <div class="pop-header align-c pd-b-0" data-ckav-sm="pd-20">
                    <p class="sq90 inline-flex flex-cc fs80 mr-0 txt-default"><i class="pe-7s-bell"></i></p>
                    <h2 class="title mr-0" data-ckav-sm="small">Newsletter</h2>
                </div>
                <div class="pop-body" data-ckav-sm="pd-20">
                    
                    <div class="form-block">
                        <form action="form-data/notify-me.php" data-formtype="newsletter" class="form-widget" novalidate="novalidate">
                            <div class="field-wrp">
                                <input type="hidden" name="to" value="c.kav.art@gmail.com">
                                <div class="form-group">
                                    <input class="form-control" data-label="Name" required="" data-msg="Please enter name." type="text" name="name" placeholder="Enter your name">
                                </div>
                                <div class="form-group">
                                    <input class="form-control" data-label="Email" required="" data-msg="Please enter email." type="email" name="email" placeholder="Enter your email">
                                </div>
                            </div>
                            <button type="submit" class="btn solid btn-default block"><i class="fa fa-envelope-o"></i> SUBMIT</button>
                        </form>
                    </div>
                </div>
            </div> -->
            
        </div>
    </ng-container>
   
  <!-- ************** END : MAIN WRAPPER **************  -->